var _style, _path, _path2, _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "308.9px",
    height: "60px",
    viewBox: "0 0 308.9 60",
    style: {
      enableBackground: "new 0 0 308.9 60"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3003E;}\r\n\t.st1{clip-path:url(#SVGID_00000135665854276607662220000017966374990574996903_);}\r\n\t.st2{clip-path:url(#SVGID_00000140710135830615486310000018164617761592000641_);fill:#D3003E;}\r\n\t.st3{clip-path:url(#SVGID_00000140710135830615486310000018164617761592000641_);fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "wetbewerbslogo-rgb_00000139260452864796313710000015708944587544896660_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 308.9,
    height: 60
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142172621274877470680000006540743594582001319_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000142172621274877470680000006540743594582001319_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000029027536413119888010000002124880241966511752_",
    y: 0,
    width: 308.9,
    height: 60
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160880794400816070920000000744617029281843108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029027536413119888010000002124880241966511752_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#D3003E"
    },
    d: "M308.9,0H160.3 l-29.5,60h139c5.2,0,10-2.9,12.3-7.6L308.9,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#D3003E"
    },
    points: "54.5,5.1  41.2,36.5 40.4,38.6 40.2,38.6 38.4,5.1 27.7,5.1 13.1,38.6 13,38.6 12.9,36.1 11.9,5.1 0,5.1 3.2,54.8 14.5,54.8 28.7,22  28.8,22 30.5,54.9 42,54.9 64.1,5.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#D3003E"
    },
    points: "93.8,5.1  76.6,40.6 73.5,5.1 70.5,5.1 62.9,22.2 66.4,54.9 78.9,54.9 103.6,5.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#D3003E"
    },
    points: "133.9,5.1  116.7,40.6 113.6,5.1 110.6,5.1 102.8,20.8 106.4,54.9 119,54.9 143.6,5.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    d: "M189.1,7.9v11.7 c0,1.2-0.3,2.4-0.8,3.4c-0.6,1-1.4,1.7-2.4,2.2c-1.2,0.5-2.5,0.8-3.7,0.8c-2.2,0-3.9-0.6-5.1-1.7c-1.3-1.2-2-2.9-1.9-4.6V7.9h4.3 v11.9c0,2,1,2.9,2.7,2.9c0.7,0.1,1.5-0.2,2-0.7c0.5-0.5,0.7-1.3,0.7-2.4V7.9H189.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    points: "199.4,7.9  203.3,20.3 207.3,7.9 213,7.9 213,25.7 208.7,25.7 208.7,21.5 209.1,13 204.8,25.7 201.9,25.7 197.6,13 198,21.5 198,25.7  193.7,25.7 193.7,7.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    points: "231.4,19.1  233.5,7.9 237.7,7.9 234,25.7 229.5,25.7 227.1,15.5 224.8,25.7 220.3,25.7 216.5,7.9 220.8,7.9 222.8,19.1 225.3,7.9 228.9,7.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    points: "252.4,18.1  245.6,18.1 245.6,22.4 253.6,22.4 253.6,25.7 241.3,25.7 241.3,7.9 253.6,7.9 253.6,11.2 245.6,11.2 245.6,15 252.4,15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    points: "261.5,22.4  269,22.4 269,25.7 257.2,25.7 257.2,7.9 261.5,7.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    points: "284.2,11.2  278.9,11.2 278.9,25.7 274.6,25.7 274.6,11.2 269.3,11.2 269.3,7.9 284.2,7.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    d: "M161.9,43.8v7h-2.4 V33h6.6c2,0,3.5,0.5,4.6,1.5c1.1,1,1.7,2.5,1.7,4c0,1.7-0.5,3.1-1.6,4c-1.1,0.9-2.6,1.4-4.7,1.4L161.9,43.8z M161.9,41.9h4.2 c1,0.1,2.1-0.2,2.9-0.9c0.7-0.7,1.1-1.6,1-2.6c0-1-0.3-1.9-1-2.6c-0.8-0.7-1.7-1-2.8-1h-4.4V41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    d: "M183.9,43.6h-4.2v7.2 h-2.4V33h5.9c2,0,3.6,0.5,4.6,1.4s1.6,2.2,1.6,4c0,1-0.3,2.1-0.9,2.9c-0.6,0.9-1.5,1.5-2.5,1.9l4.2,7.6v0.1h-2.5L183.9,43.6z  M179.7,41.7h3.6c1,0.1,2-0.3,2.8-0.9c0.7-0.6,1.1-1.5,1-2.4c0.1-1-0.3-1.9-1-2.5c-0.8-0.6-1.8-1-2.8-0.9h-3.6L179.7,41.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    points: "204.7,42.6  197,42.6 197,48.9 206,48.9 206,50.8 194.7,50.8 194.7,33 205.9,33 205.9,34.9 197,34.9 197,40.6 204.7,40.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 33,
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    width: 2.4,
    height: 17.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000160880794400816070920000000744617029281843108_)",
      fill: "#FFFFFF"
    },
    d: "M224.8,42.9 c-2-0.6-3.5-1.3-4.4-2.1c-0.9-0.8-1.4-1.9-1.4-3.1c0-1.4,0.6-2.7,1.7-3.5c1.3-1,2.8-1.5,4.4-1.4c1.1,0,2.3,0.2,3.3,0.7 c0.9,0.4,1.7,1.1,2.2,2c0.5,0.8,0.8,1.8,0.8,2.7H229c0-1-0.3-1.9-1-2.6c-0.8-0.7-1.9-1-2.9-0.9c-1-0.1-1.9,0.2-2.7,0.8 c-0.7,0.5-1,1.3-1,2.1c0,0.7,0.3,1.4,0.9,1.8c1,0.6,2,1.1,3.2,1.3c1.2,0.3,2.4,0.8,3.5,1.4c0.8,0.4,1.4,1,1.9,1.8 c0.4,0.7,0.6,1.5,0.6,2.4c0,1.4-0.6,2.7-1.7,3.5c-1.1,0.9-2.6,1.3-4.5,1.3c-1.2,0-2.3-0.2-3.4-0.7c-1-0.4-1.8-1.1-2.5-1.9 c-0.6-0.8-0.9-1.8-0.9-2.8h2.4c0,1,0.4,2,1.2,2.6c0.9,0.7,2,1,3.2,0.9c1,0.1,2-0.2,2.9-0.8c0.7-0.5,1-1.3,1-2.1 c0-0.8-0.3-1.5-0.9-2C227.1,43.6,226,43.1,224.8,42.9"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.b6a0f8880ad2a0ef8aa884f5ed6a0fa6.svg";